<script setup lang="ts">
  import sodium from "libsodium-wrappers";

  const { t } = useI18n();
  useHead({
    title: t("shared.relief-insights-enumerator"),
  });

  const tryUploadingData = ref(false);

  const { hasPlatformAccess } = storeToRefs(useSubscriptionStore());
  const { isLoggedIn } = storeToRefs(useUserStore());
  const isOnline = useOnline();

  watch(
    [isOnline, isLoggedIn, hasPlatformAccess],
    () => {
      if (
        isLoggedIn.value &&
        hasPlatformAccess.value &&
        isOnline.value
      ) {
        tryUploadingData.value = true;
      } else {
        tryUploadingData.value = false;
      }
    },
    { immediate: true },
  );

  onMounted(async () => {
    await sodium.ready;
  });
</script>

<template>
  <UApp>
    <ClientOnly>
      <OfflineUploadData v-if="tryUploadingData" />
    </ClientOnly>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
